
export function sendReadyMessage() {
    console.log("[@cruxcode/testpdfviewer] sendReadyMessage");
    parent.postMessage({ channel: "status", body: "documentReady" }, "*");
}

/**
 * 
 * @param {MTextHighlight} highlight 
 */
export function sendTextHighlightedMessage(highlight) {
    console.log("[@cruxcode/testpdfviewer] sendTextHighlight");
    parent.postMessage({ channel: "event", body: { type: "textHighlighted", data: highlight } }, "*");
}

/**
 * @param {MSelection} mSelection
 */
export function sendMSelection(mSelection){
    console.log("[@cruxcode/testpdfviewer] sendMSelection");
    parent.postMessage({ channel: "event", body: { type: "selection", data: mSelection } }, "*");
}